module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-ExtraLight.c821a21.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-ExtraLight.otf
// module id = aFsi
// module chunks = 1